export default function Terms3() {
    return (
        <>
            <p>【개인정보 및 개인위치정보 처리방침】</p>
            <p>제1장 총칙</p>
            <p>제1조 (목적)</p>
            <p>(주)코엑스, (주)지에스아이엘(이하 “회사”라 합니다)은 회원의 개인정보 및 개인위치정보를 소중하게 생각하고며 회원의 개인정보 및 개인위치정보를 효과적으로 관리하고 안전하게 보호하기 위하여 최선의 노력을 다하고 있습니다. 회사는 『개인정보보호법』 및 『개인위치정보보호법』, 기타 개인정보개인위치정보 보호 관련 각종 법규를 준수하고 있습니다. 또한 개인정보 및 개인위치정보 처리방침을 제정하여 이를 준수하고 있으며, 본 처리방침을 해당 플랫폼에 공개하여 회원께서 상시 손쉽게 열람하실 수 있도록 하고 있습니다.</p>
            <p>① 개인정보라 함은 생존하는 개인에 관한 정보로서 성명, 생년월일, 성별 등에 의하여 당해 개인을 알아볼 수 있는 부호, 문자, 음성, 음향, 영상 및 생체 특성 등에 관한 정보(당해 정보만으로는 특정 개인을 알아볼 수 없는 경우에도 다른 정보와 용이하게 결합하여 알아볼 수 있는 것을 포함)를 말합니다.</p>
            <p>② 위치정보라 함은 이동성이 있는 물건 또는 개인이 특정한 시간에 존재하거나 존재하였던 장소에 관한 정보를 말하며, 개인위치정보라 함은 특정 개인의 위치정보(위치정보만으로는 특정 개인의 위치를 알 수 없는 경우에도 다른 정보와 용이하게 결합하여 특정 개인의 위치를 알 수 있는 것을 포함한다)를 말한다.</p>
            <p>③ 회사는 회원의 개인정보 및 개인위치정보를 중요시하며, 『개인정보보호법』 및 『개인위치정보보호법』, 기타 관련 법규를 준수하고 있습니다.</p>
            <p>④ 회사는 개인정보 및 개인위치정보 처리방침을 통하여 회원의 개인정보와 개인위치정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보 및 개인위치정보 보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.</p>
            <p>⑤ 회사의 개인정보 처리방침은 관련 법령 및 내부 운영 방침의 변경에 따라 개정될 수 있습니다. 개인정보 처리방침이 변경되는 경우에는 시행일자 등을 부여하여 개정된 내용을 해당 플랫폼에 즉시 공지합니다.</p>
            <p>제2장 개인정보 처리방침</p>
            <p>제2조 (개인정보의 수집•이용 등)</p>
            <p>① 회사는 서비스 제공을 위해 필요한 최소한의 개인정보만을 수집•이용하며, 사상, 신념, 학력 등 회원의 권리•이익이나 사생활을 뚜렷하게 침해할 우려가 있는 개인정보는 수집하지 않습니다. 단, 회원께서 동의하시거나 다른 법률에 따라 특별히 수집 대상 개인정보로 허용된 경우에는 필요한 범위에서 최소한으로 해당 개인정보를 수집할 수 있습니다.</p>
            <p>② 회원가입 시점에 회사가 회원으로부터 수집하는 개인정보수집.이용의 목적 및 보유기간은 회원 유형별로 아래와 같습니다.</p>
            <table>
                <tbody>
                <tr>
                    <td className='border' colSpan={1}>회원 유형</td>
                    <td className='border' colSpan={4}>근로자</td>
                </tr>
                <tr>
                    <td className='border' colSpan={1}>개인정보 항목</td>
                    <td className='border' colSpan={4}>
                        <p>[필수 항목]</p>
                        <p>비밀번호, 성명, 휴대폰 번호, 근로자 서명, 행사명, 업체명, 업종</p>
                        <p>[선택 항목]</p>
                        <p>근로자 사진, 기초 안전 교육증</p>
                    </td>
                </tr>
                </tbody>
            </table>
            <p>• 수집.이용 목적 : 서비스 이용에 따른 본인 식별.인증 절차, 서비스 가입.변경 처리 이용에 있어서 회원 유형별 권한 제어</p>
            <p>• 보유 기간 : 서비스 가입 기간 및 현장 준공 후 3년간 보유. 단, 사고 이력이 있는 근로자 개인정보는 별도 보관</p>
            <p>③ 회사는 스마트폰 앱 서비스로서 회원께서 접근 권한을 허용하였다고 하여 단말기 정보 등으로부터 허용된 권한 관련 모든 정보가 즉시 수집(전송)되는 것은 아니며, 회원으로부터 개인정보 수집∙이용 동의를 받은 범위 내에서, 단말기 정보 등에 접근한다는 것을 고지 및 승인된 후 수집됩니다.</p>
            <p>④ 본 서비스를 위하여 회원의 연락처, 이름, 현장 정보 및 회원이 선택적으로 입력한 기타 정보는 회원이 열람할 수 있습니다. 단, 개인정보보호법 제35조 제4항의 규정에 의하여 열람이 제한될 수 있습니다.</p>
            <p>⑤ 기타 관련 법령에 근거하여 별도로 보관하는 사항은 아래와 같습니다.</p>
            <table>
                <tbody>
                <tr>
                    <td className='border' colSpan={2}>보존 근거</td>
                    <td className='border' colSpan={4}>보존 대상</td>
                    <td className='border' colSpan={1}>보존 기간</td>
                </tr>
                <tr>
                    <td className='border' colSpan={2} rowSpan={5}>산업안전보건법</td>
                    <td className='border' colSpan={4}>안전보건관리책임자, 안전관리자, 보건관리자, 안전보건관리담당자 및 산업보건의의 선임에 관한 서류에 포함된 개인정보</td>
                    <td className='border' colSpan={1}>3년</td>
                </tr>
                <tr>
                    <td className='border' colSpan={4}>제24조 제3항 및 제75조 제4항에 따른 회의록에 포함된 개인정보</td>
                    <td className='border' colSpan={1}>3년</td>
                </tr>
                <tr>
                    <td className='border' colSpan={4}>안전조치 및 보건조치에 관한 사항으로서 고용노동부령으로 정하는 사항을 적은 서류에 포함된 개인정보</td>
                    <td className='border' colSpan={1}>3년</td>
                </tr>
                <tr>
                    <td className='border' colSpan={4}>제57조 제2항에 따른 산업재해의 발생 원인 등 기록에 포함된 개인정보</td>
                    <td className='border' colSpan={1}>3년</td>
                </tr>
                <tr>
                    <td className='border' colSpan={4}>제129조부터 제131조까지의 규정에 따른 건강진단에 관한 서류에 포함된 개인정보</td>
                    <td className='border' colSpan={1}>3년</td>
                </tr>
                <tr>
                    <td className='border' colSpan={2} rowSpan={2}>통신비밀보호법</td>
                    <td className='border' colSpan={4}>통신사실 확인자료 제공에 필요한 성명, 주민등록번호, 전화번호 및 가입자의 정보통신 일시, 정보통신 개시•종료시간, 발•착신 통신번호 등 상대방의 가입자 번호, 사용도수, 발신 기지국의 위치정보</td>
                    <td className='border' colSpan={1}>12개월</td>
                </tr>
                <tr>
                    <td className='border' colSpan={4}>컴퓨터 통신 또는 인터넷의 로그 기록자료, 정보통신 기기의 위치를 확인할 수 있는 접속지의 추적 자료</td>
                    <td className='border' colSpan={1}>3개월</td>
                </tr>
                <tr>
                    <td className='border' colSpan={2}>근로기준법</td>
                    <td className='border' colSpan={4}>성명, 성별, 생년월일, 주소, 이력, 종사 업무종료, 고용 또는 고용갱신 연월일, 계약기간 정한 경우 그 기간, 그 밖의 고용에 관한 사항, 해고 퇴직 또는 사망한 경우 그 일자와 사유 및 그 밖의 필요한 사항</td>
                    <td className='border' colSpan={1}>3년</td>
                </tr>
                </tbody>
            </table>
            <p>제3조 (개인정보의 수집방법)</p>
            <p>회사는 다음과 같은 방법으로 개인정보를 수집합니다.</p>
            <p>• 회원가입 및 서비스 이용 과정에서 이용자가 개인정보 수집에 대해 동의를 하고 직접 정보를 입력하는 경우, 해당 개인정보 수집</p>
            <p>• 고객센터를 통한 상담 과정에서 웹페이지, 앱, 전화 등을 통한 수집</p>
            <p>• 기기정보와 같은 생성정보는 PC웹, 모바일 앱 이용 과정에서 자동으로 생성 및 수집</p>
            <p>• 서비스 이용 또는 업무 처리 과정에서 생성되거나 제휴사 등 제3자로부터 제공 및 생성정보 수집 툴을 통한 수집 등</p>
            <p>제4조 (개인정보 수집 및 이용 등에 관한 동의 방법)</p>
            <p>① 회원의 개인정보를 수집할 때는 관련 법령의 규정에 따라 개인정보의 수집 이용 목적과 제3자 제공 및 처리를 위탁하고 있는 내용을 회원께 알리고 동의를 얻거나 개인정보 처리방침을 통해 고지하고 있습니다.</p>
            <p>② 웹사이트(모바일 앱 포함)에 가입 또는 서비스 이용 시 이 사이트에 게시된 '서비스 이용약관' 및 '개인정보 처리방침'에 따른 회원의 개인정보 수집.이용, 제3자 제공 및 처리업무의 위탁 등에 대해 ‘동의’버튼 또는 ‘동의하지 않음’ 버튼을 클릭할 수 있습니다.</p>
            <p>③ 회원과 개인정보 주체가 다를 경우 회사는 회원으로 하여금 회사를 대신하여 개인정보 주체로부터 개인정보의 수집에 대한 동의를 받아줄 것을 요청할 수 있습니다.</p>
            <p>제5조 (개인정보의 파기절차 및 방법)</p>
            <p>회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다. 파기 절차 및 방법은 다음과 같습니다.</p>
            <p>1. 파기절차</p>
            <p>• 회원의 개인정보는 수집 및 이용목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유(보유 및 이용기간 참조)에 따라 일정 기간 저장된 후 파기됩니다.</p>
            <p>• 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.</p>
            <p>2. 파기방법</p>
            <p>• 종이(서면)에 작성·출력된 개인정보 : 분쇄하거나 소각 등의 방법으로 파기</p>
            <p>• DB 등 전자적 파일 형태로 저장된 개인정보 : 재생할 수 없는 기술적 방법으로 삭제</p>
            <p>제6조 (개인정보의 제3자 제공)</p>
            <p>원칙적으로 정보주체의 개인정보를 수집·이용 목적으로 명시한 범위 내에서 처리하며, 다음의 경우를 제외하고는 정보주체의 사전 동의 없이는 본래의 목적 범위를 초과하여 처리하거나 제3자에게 제공하지 않습니다.</p>
            <p>• 정보주체로부터 별도의 동의를 받은 경우</p>
            <p>• 다른 법률에 특별한 규정이 있는 경우</p>
            <p>• 정보주체 또는 그 법정대리인이 의사표시를 할 수 없는 상태에 있거나 주소불명 등으로 사전 동의를 받을 수 없는 경우로서 명백히 정보주체 또는 제3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요하다고 인정되는 경우</p>
            <p>• 개인정보를 목적 외의 용도로 이용하거나 이를 제3자에게 제공하지 아니하면 다른 법률에서 정하는 소관 업무를 수행할 수 없는 경우로서 회사의 심의, 의결을 거친 경우</p>
            <p>• 조약, 그 밖의 국제협정의 이행을 위하여 외국정부 또는 국제기구에 제공하기 위하여 필요한 경우</p>
            <p>• 범죄의 수사와 공소의 제기 및 유지를 위하여 필요한 경우</p>
            <p>• 법원의 재판업무 수행을 위하여 필요한 경우</p>
            <p>• 형(刑) 및 감호, 보호처분의 집행을 위하여 필요한 경우</p>
            <p>제7조 (개인정보 처리의 위탁)</p>
            <p>회사는 이 서비스의 원활한 운영을 위하여 수집된 개인정보 업무 처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있을 시, 개인정보 처리 위탁과 관련한 자세한 사항은 해당 플랫폼에 게재하여 회원이 확인할 수 있도록 안내하고 있습니다.</p>
            <p>제8조 (회원 및 법정대리인의 권리와 그 행사 방법)</p>
            <p>① 회원께서는 언제든지 회원정보 메뉴에서 자신의 개인정보를 조회하거나 수정할 수 있으며, 회원 탈퇴 메뉴를 통해 개인정보의 수집 및 이용 동의를 철회할 수 있습니다.</p>
            <p>② 회원의 개인정보 등에 대한 열람 및 정정을 위해서는 회원(법정대리인)께서 회사에 서면, 전화, 이메일 주소, FAX를 통하여 요청하시거나 해당 플랫폼의 ‘마이페이지’를 클릭하여 직접 열람 및 정정할 수 있습니다. 가입해지(동의 철회)를 위해서는 ‘회원 탈퇴’를 클릭하여 본인 확인 절차를 거치신 후 탈퇴가 가능합니다.</p>
            <p>③ 회원께서는 개인정보 등의 열람이나 제공을 요청하실 수 있으며, 회사는 이러한 요청에 지체 없이 필요한 조치를 취합니다.</p>
            <p>④ 회원께서 개인정보 등의 오류에 대한 정정을 요청하신 경우에는 지체없이 그 오류를 정정하거나 정정하지 못하는 사유를 이용자에게 알리는 등 필요한 조치를 하고, 필요한 조치를 할 때까지는 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체없이 통지하여 정정이 이루어지도록 조치하겠습니다. 다만, 다른 법률에 따라 개인정보의 제공을 요청받은 경우에는 그 개인정보를 제공하거나 이용할 수 있습니다.</p>
            <p>⑤ 회사는 회원의 요청에 의해 해지 또는 삭제된 개인정보를 본 방침 제2장에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.</p>
            <p>제9조 (개인정보의 안전성 확보조치)</p>
            <p>회사는 회원의 개인정보가 분실, 도난, 유출, 위조, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 관리적, 기술적, 물리적 대책을 마련하고 있습니다.</p>
            <p>1. 관리적 조치 : 내부관리계획 수립·시행, 정기적 직원 교육 등</p>
            <p>2. 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제 시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치</p>
            <p>3. 물리적 조치 : 서버실, 자료보관실 등의 접근통제</p>
            <p>제3장 개인위치정보 처리방침</p>
            <p>회사는 “위치정보의 보호 및 이용 등에 관한 법률”에 따라 회원의 개인위치정보를 안전하게 관리합니다.</p>
            <p>제10조 (개인위치정보의 처리 목적 및 보유기간)</p>
            <p>회사는 개인위치정보를 활용하여 근로자 안전서비스를 제공할 목적으로 개인위치정보를 처리합니다. 회사는 대부분의 위치기반서비스에서 개인위치정보를 일회성 또는 임시로 이용 후 즉시 파기합니다.</p>
            <p>제11조 (개인위치정보 수집∙이용∙제공사실 확인자료의 보유근거 등)</p>
            <p>회사는 “위치정보의 보호 및 이용 등에 관한 법률” 제16조 제2항에 근거하여 이용자의 위치정보 수집∙이용∙제공사실 확인자료를 위치정보 시스템에 자동으로 기록하며, 6개월 이상 보관합니다.</p>
            <p>제12조 (개인위치정보의 파기 절차 및 방법)</p>
            <p>회사는 개인위치정보의 처리목적이 달성된 경우, 개인위치정보를 재생이 불가능한 방법으로 안전하게 파기하고 있습니다. 전자적 파일 형태는 복구 및 재생이 불가능한 기술적인 방법을고 파기하며, 출력물 등은 분쇄하거나 소각하는 방식으로 파기합니다.</p>
            <p>제13조 (개인위치정보의 제3자 제공 및 통보에 관한 사항)</p>
            <p>회사는 회원의 사전 동의 없이 개인위치정보를 제3자에게 제공하지 않으며, 이용자가 지정한 제3자에게 개인위치정보를 제공하는 경우 매회 개인위치정보주체에게 제공받는 자, 제공일시 및 제공목적을 즉시 통보합니다.</p>
            <p>제14조 (8세 이하 등의 보호의무자 권리∙의무 및 그 행사방법)</p>
            <p>① 회사는 아래의 경우에 해당하는 회원(이하 “8세 이하의 아동 등”이라 함)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를 위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.</p>
            <p>- 8세 이하의 아동</p>
            <p>- 피성년후견인</p>
            <p>- 장애인복지법 제2조 제2항 제2호의 규정에 의한 정신적 장애를 가진 자로서 장애인고용촉진 및 직업재활법 제2조 제2호의 규정에 의한 중증장애인에 해당하는 자(장애인복지법 제32조의 규정에 의하여 장애인등록을 한 사람에게 한정)</p>
            <p>② 8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의를 하고자 하는 보호의무자는 서면동의서에 보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.</p>
            <p>③ 보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 개인위치정보주체 권리의 전부를 행사할 수 있습니다.</p>
            <p>제 4장 정보보호 책임부서 및 연락처 등</p>
            <p>제15조 (개인정보 및 개인위치정보 보호책임 부서∙연락처)</p>
            <p>① 회사는 회원의 개인정보 및 개인위정보처리에 관한 업무를 총괄해서 책임지고, 개인정보 및 개인위치정보처리와 관련한 회원의 불만처리 및 피해구제를 위하여 아래와 같이 개인정보 및 개인위치정보 보호책임자를 지정하고 있습니다.</p>
            <table>
                <tbody>
                <tr>
                    <td className='border'>역할</td>
                    <td className='border'>담당자</td>
                    <td className='border'>연락처</td>
                </tr>
                <tr>
                    <td className='border'>개인정보{'\n'}보호책임자</td>
                    <td className='border'>(주)지에스아이엘{'\n'}대표이사</td>
                    <td className='border'>02-6247-7500</td>
                </tr>
                <tr>
                    <td className='border'>개인정보{'\n'}보호담당자</td>
                    <td className='border'>(주)지에스아이엘{'\n'}S100 플랫폼/AI 파트장</td>
                    <td className='border'>02-6247-7504</td>
                </tr>
                </tbody>
            </table>
            <p>② 회원께서는 해당 플랫폼을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 및 개인위치정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 회사는 회원의 문의에 대해 지체없이 답변 및 처리해 드리겠습니다.</p>
            <p>제16조 (개인정보 및 개인위치정보 열람청구)</p>
            <p>회사는 회원의 개인정보 열람 청구를 위하여 아래와 같이 관련 부서를 지정하여 운영하고 있습니다. 회원께서 본 서비스에 개인정보 열람을 청구하실 경우 아래 부서 담당자에게 문의하시면 신속하고 성실하게 답변 드리겠습니다.</p>
            <table>
                <tbody>
                <tr>
                    <td className='border'>부서명</td>
                    <td className='border'>담당자</td>
                    <td className='border'>연락처</td>
                </tr>
                <tr>
                    <td className='border'>(주)지에스아이엘{'\n'}S100 플랫폼/AI</td>
                    <td className='border'>파트장</td>
                    <td className='border'>02-6247-7504</td>
                </tr>
                </tbody>
            </table>
            <p>제17조 (권익침해 구제방법)</p>
            <p>기타 개인정보 및 개인위치정보 침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하여 주시기 바랍니다.</p>
            <table>
                <tbody>
                <tr>
                    <td className='border'>기관명</td>
                    <td className='border'>소관 업무</td>
                    <td className='border'>연락처</td>
                </tr>
                <tr>
                    <td className='border'>개인정보침해신고센터</td>
                    <td className='border'>개인정보침해사실 신고, 상담운영</td>
                    <td className='border'>privacy.kisa.or.kr{'\n'}(국번없이) 118</td>
                </tr>
                <tr>
                    <td className='border'>개인정보분쟁조정위원회</td>
                    <td className='border'>개인정보 분쟁조정신청</td>
                    <td className='border'>www.kopico.go.kr{'\n'}(국번없이){'\n'}1833-6972</td>
                </tr>
                <tr>
                    <td className='border'>대검찰청{'\n'}사이버수사과</td>
                    <td className='border'>-</td>
                    <td className='border'>www.spo.go.kr{'\n'}(국번없이) 1301</td>
                </tr>
                <tr>
                    <td className='border'>경찰철{'\n'}사이버수사국</td>
                    <td className='border'>-</td>
                    <td className='border'>ecrm.cyber.go.kr{'\n'}(국번없이) 182</td>
                </tr>
                </tbody>
            </table>
            <p>제18조 (개인정보 및 개인위치정보 처리방침 고지)</p>
            <p>1. 이 개인정보 처리방침은 2023년 05월 01일부터 적용됩니다.</p>
        </>
    );
}